import React from "react";
import PropTypes from "prop-types";
import LocalNavSoftLink from "../LocalNavSoftLink";
import LocalNavHardLink from "../LocalNavHardLink";

export default function CompanyFieldManagementSection({
    hasCompanySelected,
    isCompanyHasManageAccess,
    hasSuperAdmin,
    hasVisibilityForCompany,
    hastEditFieldRatesFeature,
    onEditFieldLabels,
    onCloneFieldLabels,
}) {
    if (!hasCompanySelected) return null;

    return (
        <>
            <LocalNavHardLink
                removeLi
                id="singleview-control-center"
                destination="/ClientAccess/SingleViewControlCenter"
                text="SingleView Control Center"
            />
            {isCompanyHasManageAccess && hasSuperAdmin && (
                <LocalNavSoftLink
                    removeLi
                    id="manage-access"
                    destination="/admin/manage-access"
                    text="Manage Access"
                    feature="manage-access"
                />
            )}
            <LocalNavSoftLink removeLi id="edit-fields" destination="/admin/fields/edit" text="Edit Fields" />
            <LocalNavSoftLink
                removeLi
                id="edit-fields-bulk"
                destination="/admin/fields/bulk-actions"
                text="Field Bulk Management"
            />
            {hasVisibilityForCompany && (
                <LocalNavSoftLink
                    removeLi
                    id="edit-import-fields-bulk"
                    destination="/admin/fields/import-bulk-actions"
                    text="Field Visibility Bulk Management"
                />
            )}
            <a
                id="edit-field-labels"
                href="#"
                onClick={e => {
                    e.preventDefault();
                    onEditFieldLabels();
                }}
                style={{ color: "#575755", textDecoration: "none" }}
            >
                Edit Field Labels
            </a>
            {hastEditFieldRatesFeature && (
                <LocalNavSoftLink removeLi id="field-rates" destination="/admin/fields/rates" text="Edit Field Rates" />
            )}
            <a
                id="clone-field-labels"
                href="#"
                onClick={e => {
                    e.preventDefault();
                    onCloneFieldLabels();
                }}
                style={{ color: "#575755", textDecoration: "none" }}
            >
                Clone Field Labels and Visibility
            </a>
            <LocalNavSoftLink
                removeLi
                id="restricted-fields"
                destination="/admin/restricted-fields"
                text="Edit Restricted Fields"
            />
            <LocalNavSoftLink removeLi id="edit-joins" destination="/admin/joins" text="Edit Joins" />
        </>
    );
}

// Mark safe for LocalNavMenu structural expansion (must remain hook-free)
CompanyFieldManagementSection.__localNavSection = true;

CompanyFieldManagementSection.propTypes = {
    hasCompanySelected: PropTypes.bool.isRequired,
    isCompanyHasManageAccess: PropTypes.bool.isRequired,
    hasSuperAdmin: PropTypes.bool.isRequired,
    hasVisibilityForCompany: PropTypes.bool.isRequired,
    hastEditFieldRatesFeature: PropTypes.bool.isRequired,
    onEditFieldLabels: PropTypes.func.isRequired,
    onCloneFieldLabels: PropTypes.func.isRequired,
};
